// extracted by mini-css-extract-plugin
module.exports = {"ErrorBoundary":"styles_ErrorBoundary__bzjDs","ErrorBlock":"styles_ErrorBlock__S5Fvc"};